<div class="backdrop" [ngClass]="{ 'backdrop-visible': drawer.opened }" (click)="toggleSendEmail()"></div>
<mat-sidenav #sendEmailDrawer class="right-side-nav-container display-flex" opened="false" position="end" mode="over" [fixedInViewport]="true">
  <div class="row row--space-between mb--md">
    <label>{{ 'App.SendEmail.Labels.SendEmail' | translate }}</label>
    <button mat-button class="float-right" (click)="toggleSendEmail()">
      <span class="icon-x"></span>
    </button>
  </div>
  <form [formGroup]="sendEmailForm">
    <div class="row display-column-flex column--12">
      <mat-form-field hideRequiredMarker appearance="outline">
        <mat-label>{{ 'App.SendEmail.Placeholders.EmailAddress' | translate }}</mat-label>
        <input matInput formControlName="emailAddress" name="emailAddress" value="" required />
        <mat-error>{{ 'App.SendEmail.Labels.InvalidInput' | translate }} </mat-error>
      </mat-form-field>
    </div>
  </form>
  <div class="mt--auto mb-sm" >
    <button mat-button class="primary-button rounded w-100 mb--sm" (click)="onSendEmail()" [disabled]="sendEmailForm.invalid">
      <span>{{ 'App.SendEmail.Buttons.SendEmail' | translate }}</span>
    </button>
    <button mat-button class="hollow-button rounded w-100" (click)="toggleSendEmail()">
      <span>{{ 'App.SendEmail.Buttons.Cancel' | translate }}</span>
    </button>
  </div>
</mat-sidenav>
